import { TaskBallColor } from '../enums/TaskBallColor';

export const defaultBallColors = [
  { label: '#FF0000', rgb: { r: 255, g: 0, b: 0 } }, // Red      hsl(0   100% 50%)
  { label: '#FF8000', rgb: { r: 255, g: 128, b: 0 } }, // Orange   hsl(30  100% 50%)
  { label: '#FFFF00', rgb: { r: 255, g: 255, b: 0 } }, // Yellow   hsl(60  100% 50%)
  { label: '#00FF00', rgb: { r: 0, g: 255, b: 0 } }, // Green    hsl(120 100% 50%)
  { label: '#00FFFF', rgb: { r: 0, g: 255, b: 255 } }, // Cyan     hsl(180 100% 50%)
  { label: '#0000FF', rgb: { r: 0, g: 0, b: 255 } }, // Blue     hsl(240 100% 50%)
  { label: '#AA00FF', rgb: { r: 170, g: 0, b: 255 } }, // Purple   hsl(280 100% 50%)
  { label: '#FF00AA', rgb: { r: 255, g: 0, b: 170 } }, // Pink     hsl(320 100% 50%)
];

export const legacyDefaultColors = [
  { value: TaskBallColor.Red, label: '#B85450' },
  { value: TaskBallColor.Purple, label: '#9673A6' },
  { value: TaskBallColor.Blue, label: '#6C8EBF' },
  { value: TaskBallColor.Silver, label: '#FFF' },
];
